import { Button, Card, Col, message, Row, Select, Space, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { CALLBACK_URL, ZALO_APP_URL } from '../../config';
import api from '../../API';
import {KeyOutlined } from '@ant-design/icons';


function Connections() {
    const user = JSON.parse(localStorage.getItem('user'));
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null)
    const [dataSource, setDataSource] = useState([]);

    useEffect(() => {
        api.list_oaaccounts_by_user(user?.userId, user?.parentId,["id", "accountName", "AppId"])
        .then(oaaccounts => {
            if(oaaccounts?.length) {
                setDataSource(oaaccounts);
                setOptions(oaaccounts.map((oaaccount, i) => ({
                    value: String(i),
                    label: oaaccount.accountName
                })))
            }
        })
        .catch((error) => message.error(error.message));
      }, []);

    const generateCodeChallenge = async (codeVerifier) => {
        const encoder = new TextEncoder();
        const data = encoder.encode(codeVerifier);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const base64UrlEncoded = window.btoa(
            String.fromCharCode.apply(null, hashArray)
        )
            .replace(/=/g, '')
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
        return base64UrlEncoded;
    };

    const handleAuth =  async () => {
        if(selectedOption) {
            try {
                const str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let codeVerifier = '';
                for (let i = 0; i < 43; i++) {
                    const randomIndex = Math.floor(Math.random() * str.length);
                    codeVerifier += str[randomIndex];
                }
                await api.update_oaaccount_ById(dataSource[selectedOption].id, { code_verifier: codeVerifier })
                const codeChallenge = await generateCodeChallenge(codeVerifier);
                const authUrl = `${ZALO_APP_URL}?app_id=${dataSource[selectedOption].AppId}&redirect_uri=${CALLBACK_URL}&code_challenge=${codeChallenge}&state=true`;
                const link = document.createElement('a');
                link.href = authUrl;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                message.error(error.message);
            }
        }  
    }

    return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
            <Typography.Title level={5} style={{margin: 0}}>Connections</Typography.Title>
        }
    >
        <Row>
            <Col span={24} style={{textAlign: 'center'}}>
                <Space direction="vertical">
                    <Select 
                        options={options} 
                        style={{width: "100%"}} 
                        placeholder="Select OA Account" 
                        popupMatchSelectWidth={false}
                        showSearch
                        allowClear
                        onChange={(value) => setSelectedOption(value)}
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                    <Button type='primary' style={{width: 200, height: 40}} onClick={handleAuth} disabled={selectedOption? false: true} icon={<KeyOutlined/>}>Authorize</Button>
                </Space>
            </Col>
        </Row>
    </Card>
    )
}

export default Connections
